import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component';
import { DmsService } from 'src/app/shared/services/dms.service';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-dms-header',
  templateUrl: './dms-header.component.html',
  styleUrls: ['./dms-header.component.scss']
})
export class DmsHeaderComponent extends BaseComponent {

  public paginaSelected: number = 0;

  constructor(public dmsService: DmsService,
    public utility: UtilityService,
    private router: Router) {
    super();
  }

  homeClick() {
    this.router.navigate(['dms'], { queryParams: { oidAlbergo: this.dmsService.albergo.oid, lingua: this.dmsService.lingua } });
  }
}